import Alpine from 'alpinejs';

Alpine.store('loading', false);

window.Alpine = Alpine;

Alpine.start();
